module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "158150771761-6r447dm04enaejiq0n8ptfc63ga13bn7.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
}